module.exports = __webpack_public_path__ + "static/img/h5-6.9d3f9b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h5-6.png
// module id = qbEF
// module chunks = 1